import { RESET_USER_FORM_DATA,RESET_USER_FORM_EXCEPT_ONBEHALF, UPDATE_IS_DECEASED,UPDATE_USER_STEPS, UPDATE_COGNITO_DATA , UPDATE_3DS_DATA , UPDATE_USER_DATA , GET_USER_DATA , UPDATE_USER_ENROLL, UPDATE_IRASINCLUSION, UPDATE_SESSION_EXPIRY_ID, RESET_USER_DATA, SET_API_ERROR, UPDATE_TRANSACTION_STATUS, UPDATE_BUSNESSPAYER, SET_3DS_REQUIREMENT, UPDATE_IS_OTHERS, SET_LOGIN_MENDATORY, UPDATE_PAYMENT_MODE, UPDATE_USER_TOKEN_INFO, UPDATE_SEARCHBY_NRIC, RESET_USER_DATA_EXCEPT_STEPS, RESET_USER_DATA_EXCEPT_URL, UPDATE_USER_URL } from '../constants';

const defaultHeader = {
    title: '',
    subTitle: '',
    steps: 0
}

const paymentDetails = () => ({
    userStepsData: defaultHeader,
    transactionNo : '',
    token: '',
    paymentMode: null,
    hasIRASInclusion: null,
    isBusinessPayer: null,
    isDeceased: null,
    isOthers: null,
    redirectToOxiPay: false,
    sessionExtended: false,
    transactionPassed: false,
    transactionType: '',
    sessionId: null,
    Cookie: null,
    Token: null,
    is3DSChallenge: false,
    is3DSNeeded: false,
    isUserSignedIn: false,
    isLoginMendatory: false,
    cognitoToken: null,
    isSearchByNric: false,
    isSearchByNricValue: null,
    url: null,
    userData: {
        name: '',
        userId: '',
        aliasname: '',
        countryCode: '',
        mobile: '',
        email: '',
        registeredAddress: '',
        pincode: '',
        nric: '',
        countryofbirth: '',
        dialect: '',
        nationality: '',
        dateofbirth: '',
        sex: '',
        iAgree: true,
        race: '',
        onbehalfof: '',
        accountCreated: false,
        streetandpostal: '',
        addressObj: {
            "postalCode": "",
            "blockNumber": "",
            "streetName": "",
            "buildingName": "",
            "country": "",
            "unitNo": "",
            "floorNo": ""
        },
        token:''
    },
    apiError: false,
});

export default function userReducer(state = paymentDetails() , action) {

    let userData = action.userData;

    switch(action.type) {
        case UPDATE_USER_DATA:
            return { ...state , ...action.userdata };
        case UPDATE_USER_ENROLL:
            return { ...state , userData };
        case GET_USER_DATA:
            return state;
        case UPDATE_IRASINCLUSION: 
            return { ...state, hasIRASInclusion: action.payload }
        case UPDATE_SEARCHBY_NRIC:
            return { ...state, isSearchByNricValue: action.payload }
        case UPDATE_BUSNESSPAYER: 
            return { ...state, isBusinessPayer: action.payload }
        case UPDATE_PAYMENT_MODE: 
            return { ...state, paymentMode: action.payload }
        case UPDATE_IS_DECEASED: 
            return { ...state, isDeceased: action.payload }
        case UPDATE_IS_OTHERS: 
            return { ...state, isOthers: action.payload }
        case UPDATE_SESSION_EXPIRY_ID:
            return {...state, sessionExpiryId: action.id }
        case UPDATE_COGNITO_DATA:
            return {...state, ...action.payload }
        case UPDATE_TRANSACTION_STATUS:{
            return {
                ...state,
                transactionNo: action.status ? '': state.transactionNo, 
                transactionPassed: action.status,
            }
        }
        case UPDATE_3DS_DATA:
                return { ...state , ...action._3dsdata };
        case RESET_USER_DATA:{
            return paymentDetails();
        }
         // resetting form data except onBehalf value
        case RESET_USER_FORM_DATA: {
            const { onbehalfof } = state.userData;
            return {
                ...state,
                ...{
                    userData: {
                        ...paymentDetails().userData,
                        onbehalfof
                    }
                }
            };
        }
        case RESET_USER_FORM_EXCEPT_ONBEHALF: {
            const { onbehalfof } = state.userData;
            return {
                ...state,
                ...{
                    userData: {
                        ...paymentDetails().userData,
                        onbehalfof
                    }
                }
            };
        }
        case SET_API_ERROR:{
            return {...state, apiError: action.apiError}
        }
        case SET_LOGIN_MENDATORY:{
            return {...state, isLoginMendatory: action.status}
        }
        case UPDATE_USER_TOKEN_INFO: {
            const { tokenId, mobile, email } = action.payload;
            return {
                ...paymentDetails(),       
                userData: {
                    ...paymentDetails().userData,
                    mobile,
                    email,
                    token: tokenId,
                }
            };
        }
        case UPDATE_USER_STEPS: 
        return { ...state, userStepsData: action.payload }

        case UPDATE_USER_URL:
        return { ...state, url: action.payload }

        case RESET_USER_DATA_EXCEPT_STEPS: {
            const { userStepsData } = state; 
            return {
              ...paymentDetails(),
              userStepsData
            };
          }

        case RESET_USER_DATA_EXCEPT_URL: {
            const { url } = state; 
            return {
              ...paymentDetails(),
              url
            };
          }
        default:
            return state;
    }
}